import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToTravelQuote,
    navigateToTravelDetails,
    navigateToPayment
} from '../../../actions/travel/routing';
import { getActivePageIndex } from '../../../selectors/travel/routing';
import { PAGE_INDICES } from '../../../actions/travel/types';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS)
        return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QOUTE:
            store.dispatch(navigateToTravelDetails());
            break;
        case PAGE_INDICES.TRAVEL_DETAILS:
            store.dispatch(navigateToPayment());
            break;
        default:
            store.dispatch(navigateToTravelQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.TRAVEL_DETAILS:
            store.dispatch(navigateToTravelQuote());
            break;
        case PAGE_INDICES.PAYMENT:
            store.dispatch(navigateToTravelDetails());
            break;
        default:
            store.dispatch(navigateToTravelQuote());
            break;
    }
};
